import Supervise from '@/service/supervise'
import RequestUtils from './requestUtils.js'

export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    getallregulators(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Supervise.getallregulators(payload), {
        type: 'list',
        success,
        fail
      })
    },
    addregulator(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Supervise.addregulator(payload), {
        type: 'action',
        success,
        fail
      })
    },
    updateregulator(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Supervise.updateregulator(payload), {
        type: 'action',
        success,
        fail
      })
    },
    deleteregulator(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Supervise.deleteregulator(payload), {
        type: 'action',
        success,
        fail
      })
    },
    getregulator(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Supervise.getregulator(payload), {
        type: 'info',
        success,
        fail
      })
    },
    getflapcategorys(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Supervise.getflapcategorys(payload), {
        type: 'list',
        success,
        fail
      })
    },
    getsupervisions(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Supervise.getsupervisions(payload), {
        type: 'list',
        success,
        fail
      })
    }
  }
}
